import { Box, Container, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import useOrgAssociateCenters from 'src/hooks/useOrgAssociates';
import AssociatesTable from '../../OrgAssociateTable/OrgAssociateTable';
import SearchField from '../../SearchField/SearchField';
import { useStylesUsersPage } from '../styles';
import { useOrgDetailsStyles } from './styles';

const OrgAssociates: React.FC = () => {
  const classes = { ...useStylesUsersPage(), ...useOrgDetailsStyles() };
  const { searchQuery, updateSearchQuery } = useOrgAssociateCenters();

  useEffect(() => updateSearchQuery(''), []);

  return (
    <Container disableGutters maxWidth="xl">
      <Box mb={1}>
        <Typography
          variant="h5"
          className={classes.title}
          data-testid="adminList-title"
        >
          Associate School Management
        </Typography>
        <Typography
          variant="body1"
          className={classes.description}
          data-testid="adminList-subtitle"
        >
          Associate Schools that are in your organization
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent={['unset', 'space-between']}
        flexDirection={['column', 'row']}
        alignItems={['flex-end', 'unset']}
      >
        <Box className={classes.searchField}>
          <SearchField
            searchQuery={searchQuery}
            placeholder="Search for Associate"
            onSubmit={updateSearchQuery}
            onChange={updateSearchQuery}
          />
        </Box>
      </Box>
      <Box className={classes.table}>
        <AssociatesTable />
      </Box>
    </Container>
  );
};

export default OrgAssociates;
